// matches date.getDay() values
export enum CalendarDay {
  Monday = 1,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}
